<script>
  import { createEventDispatcher } from "svelte"
  import MetaPreviewAccordian from "./metaPreviewAccordian.svelte"
  import MetaPreviewTable from "./metaPreviewTable.svelte"

  const dispatch = createEventDispatcher()

  export let jsonData = []
  let tableView = true
</script>

<div class="fixed inset-0 z-30 h-screen w-screen select-none overflow-auto bg-[#f7f7f7]/50 backdrop-blur-md dark:bg-bodyblack/50">
  <div class="flex min-h-screen items-center justify-center gap-6 p-6">
    <!-- <div class="h-fit w-full rounded-md bg-white p-6 shadow-lg dark:bg-mdGray md:w-4/5 xl:w-3/5"> -->
    <div class="relative h-fit w-full max-w-none overflow-x-hidden rounded-md bg-white p-6 shadow-lg dark:bg-mdGray md:w-4/5 xl:w-3/5">
      <div class="mx-auto w-full space-y-3">
        <div class="flex w-full flex-col justify-between gap-3 md:flex-row">
          <div class="mb-4 select-none text-xl font-bold text-black dark:text-white lg:text-2xl xl:text-2xl">Metadata Confirmation</div>

          <button
            type="button"
            on:click={() => {
              tableView = !tableView
            }}
            class="flex h-9 min-w-[150px] items-center justify-center gap-2 rounded-md bg-green-500 px-3 py-1.5 text-sm text-white transition hover:bg-green-600 active:bg-green-500"
          >
            {#if tableView}
              <i class="fa-solid fa-bars" />
              <span>Details View</span>
            {:else}
              <i class="fa-solid fa-table" />
              <span>Table View</span>
            {/if}
          </button>
        </div>
        {#if tableView}
          <MetaPreviewTable {jsonData} />
        {:else}
          <MetaPreviewAccordian {jsonData} />
        {/if}
        <div class="flex justify-end gap-3 pt-4">
          <button
            on:click={() => {
              dispatch("onClose")
            }}
            class="h-[36px] w-fit rounded-md bg-red-500 px-5 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-red-600"
          >
            <i class="fa-solid fa-circle-xmark" />
            <span>Close</span>
          </button>
          <button
            on:click={() => {
              dispatch("onConfirm")
            }}
            class="h-[36px] w-fit rounded-md bg-green-500 px-5 py-1 text-sm font-normal tracking-wider text-white hover:border-transparent hover:bg-green-600"
          >
            <i class="fa-solid fa-circle-check" />
            <span>Confirm&nbsp;All</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
